export default "__VITE_ASSET__B0R5Kphp__"